/* eslint-disable no-underscore-dangle */
export const SET_USER = 'SET_USER';
export const SET_DATEFORMAT = 'SET_DATEFORMAT';
export const ACCOUNT_SWITCHED = 'ACCOUNT_SWITCHED';
export const IS_CSR = 'IS_CSR';
export const IS_SALES_REP = 'IS_SALES_REP';

const initialState = {
  setUser: false,
  accountNumber: '',
  accountName: '',
  apCountry: '',
  userPermision: '',
  isCSR: false,
  isSalesRep: false,
  dateFormat: '',
  accountSwitched: false,
};

export default (state = initialState, user) => {
  switch (user.type) {
    case SET_USER: {
      const data = user.user;
      return {
        ...state,
        setUser: true,
        accountNumber: data?.AP_ACCOUNT_NUMBER,
        accountName: data?.AP_CUSTOMER_NAME,
        apCountry: data?.AP_COUNTRY,
        merchantAccountStripeID: data?.AP_MERCHANT_STRIPE_ACCOUNT_ID,
        userPermision: data?.userpermission ? data?.userpermission : state.userPermision,
      };
    }
    case ACCOUNT_SWITCHED: {
      return {
        ...state,
        accountSwitched: user.payload,
      };
    }
    case IS_CSR: {
      return {
        ...state,
        isCSR: user.payload,
      };
    }
    case IS_SALES_REP: {
      return {
        ...state,
        isSalesRep: user.payload,
      };
    }
    case SET_DATEFORMAT: {
      const data = user.user;
      return {
        ...state,
        dateFormat: data['date-format']?.replace('DD', 'dd')?.replace('YYYY', 'yyyy'),
      };
    }
    default:
      return state;
  }
};

export const setUser = userdata => ({
  type: SET_USER,
  user: userdata,
});

export const setUserDateFormat = userdata => ({
  type: SET_DATEFORMAT,
  user: userdata,
});
